export default "__VITE_ASSET__DA1dpVvK__"